<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">マスター</div>
    <div v-if="isOpen" class="dropdown-menu">
      <router-link to="/master/manegement" class="dropdown-item" @click="closeDropdown"
        >自事業所情報</router-link
      >

      <router-link
        to="/master/serviceTaniTanka"
        class="dropdown-item"
        @click="closeDropdown"
        >単位数単価</router-link
      >

      <router-link to="/master/teikyoTaisei" class="dropdown-item" @click="closeDropdown"
        >提供体制</router-link
      >

      <router-link
        to="/master/teikyoTaiseiIryo"
        class="dropdown-item"
        @click="closeDropdown"
        >提供体制(医療訪問看護)</router-link
      >

      <router-link
        to="/role"
        class="dropdown-item"
        @click="closeDropdown"
        v-if="companyService.role && companyService.role.includes('Admin')"
        >役割</router-link
      >
      <router-link to="/master/staffList" class="dropdown-item" @click="closeDropdown"
        >スタッフマスター</router-link
      >
      <router-link to="/master/shiftList" class="dropdown-item" @click="closeDropdown"
        >シフトマスター</router-link
      >
      <router-link to="/master/userList" class="dropdown-item" @click="closeDropdown"
        >利用者マスター</router-link
      >

      <router-link to="/master/shippei" class="dropdown-item" @click="closeDropdown"
        >利用者疾病マスター</router-link
      >

      <router-link to="/master/officeList" class="dropdown-item" @click="closeDropdown">
        他事業所マスター</router-link
      >

      <router-link to="/master/doctorList" class="dropdown-item" @click="closeDropdown"
        >医師マスター</router-link
      >
      <router-link to="/master/taisyoList" class="dropdown-item" @click="closeDropdown"
        >処置マスター</router-link
      >
      <router-link to="/master/syohinList" class="dropdown-item" @click="closeDropdown">
        商品マスター</router-link
      >
      <router-link to="/master/tani" class="dropdown-item" @click="closeDropdown"
        >単位マスター</router-link
      >

      <router-link to="/master/satellite" class="dropdown-item" @click="closeDropdown"
        >サテライトマスター</router-link
      >

      <router-link to="/master/tatemono" class="dropdown-item" @click="closeDropdown"
        >建物マスター</router-link
      >

      <router-link to="/master/syaryo" class="dropdown-item" @click="closeDropdown"
        >車両マスター</router-link
      >

      <router-link to="/master/soko" class="dropdown-item" @click="closeDropdown"
        >倉庫マスター</router-link
      >

      <router-link to="/master/location" class="dropdown-item" @click="closeDropdown"
        >ロケーションマスター</router-link
      >

      <router-link to="/master/kyomikansin" class="dropdown-item" @click="closeDropdown"
        >興味関心マスター</router-link
      >

      <router-link to="/master/serviceCode" class="dropdown-item" @click="closeDropdown"
        >サービスコードマスター</router-link
      >

      <router-link to="/master/sogoService" class="dropdown-item" @click="closeDropdown"
        >総合事業ファイル取り込み</router-link
      >

      <router-link to="#" class="dropdown-item" @click="redirectToManage"
        >会社情報</router-link
      >
      <!-- <router-link to="/serviceUsageTable" class="dropdown-item" @click="closeDropdown">サービス提供表</router-link>
       <router-link to="/visitingNurseRecordII" class="dropdown-item" @click="closeDropdown">訪問看護記録書Ⅱ</router-link>
      <router-link to="/visitingNursePlan" class="dropdown-item" @click="closeDropdown">訪問看護計画書</router-link>
      <router-link to="/visitingNurseReport" class="dropdown-item" @click="closeDropdown">訪問看護報告書</router-link>
      <router-link to="/counter" class="dropdown-item" @click="closeDropdown">Counter</router-link>
      <router-link to="/fetch-data" class="dropdown-item" @click="closeDropdown">Fetch data</router-link>
      <router-link to="/fileupload" class="dropdown-item" @click="closeDropdown">FileUpload</router-link>
      <router-link to="/pdf" class="dropdown-item" @click="closeDropdown">PDF</router-link>
      <router-link to="/myFullCalendar" class="dropdown-item" @click="closeDropdown">FullCalendar</router-link> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps } from "vue";
import { RouterLink } from "vue-router";
import CompanyService from "../Js/CompanyService";
const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu1: Boolean,
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

const redirectToManage = () => {
  closeDropdown();
  window.location.href = `${import.meta.env.VITE_API_TARGET}/Identity/Account/Manage`;
};

watch(
  () => props.isOpenMenu1,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
